import { MapPin, AlertTriangle, Users, Share2, BadgeCheck, Clock, PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

const features = [
  { icon: MapPin, title: "Mapa interaktywna", desc: "Znajdź schroniska w okolicy" },
  { icon: AlertTriangle, title: "Pilne potrzeby", desc: "Wyróżnione na liście" },
  { icon: Users, title: "Wolontariat", desc: "Spacery i pomoc na miejscu" },
  { icon: Share2, title: "Udostępniaj", desc: "Grafiki na social media" },
  { icon: BadgeCheck, title: "Weryfikacja", desc: "Zaufane schroniska" },
  { icon: Clock, title: "Aktualność", desc: "Widoczna data aktualizacji" },
];

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content - centered */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "100px 80px",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <h1
          style={{
            fontSize: "64px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0",
            textAlign: "center",
          }}
        >
          Odkryj możliwości
        </h1>

        {/* Features grid - 3 columns */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "16px",
            width: "100%",
            maxWidth: "900px",
          }}
        >
          {features.map((f) => (
            <div
              key={f.title}
              style={{
                background: "rgba(255,255,255,0.95)",
                borderRadius: "20px",
                padding: "24px 20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                gap: "12px",
                boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
              }}
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  background: "linear-gradient(135deg, #E8F5EA 0%, #D4EED8 100%)",
                  borderRadius: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <f.icon style={{ width: "28px", height: "28px", color: "#4E8A6E" }} />
              </div>
              <div>
                <h3 style={{ fontSize: "22px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
                  {f.title}
                </h3>
                <p style={{ fontSize: "16px", color: "#6B8A7A", margin: "4px 0 0", fontWeight: 500 }}>
                  {f.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Logo with brand name - fixed position */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
      </div>
    </GraphicBackground>
  );
};

